import React from "react";
import styles from "./boton.module.css";

const Boton = ({ children, agregarValor }) => {
  return (
    <div
      className={styles.boton}
      onClick={() => {
        agregarValor(children);
      }}
    >
      {children}
    </div>
  );
};

export default Boton;
